import { gameLoop } from "appworks/core/game-loop";
import { Model } from "appworks/model/model";
import { commsManager } from "appworks/server/comms-manager";
import { Services } from "appworks/services/services";
import { stateMachine } from "appworks/state-machine/state-machine";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Timer } from "appworks/utils/timer";
import { DebugTab } from "slotworks/debug/menu/tabs/debug-tab";
import { debugSpinTimer } from "slotworks/debug/spin-timer";
import { slotModel } from "slotworks/model/slot-model";

export class UtilTab extends DebugTab {
    private static crashTimer?: number;

    public render(root: HTMLElement, hide: Function): void {
        this.addFramerateDebugger(root, hide);
        this.addSpeedDebugger(root, hide);
        this.addNetworkDelay(root, hide);
        this.addFPSToggle(root);
        this.addMusicToggle(root, hide);
        this.addAutoTurbo(root, hide);
        this.addSpinTimer(root);
        this.addCrash(root, hide);
    }

    private addFramerateDebugger(root: HTMLElement, hide: Function) {
        const inputText = document.createElement("input");
        inputText.type = "text";
        inputText.style.fontSize = "3vw";
        inputText.style.margin = "1vmax 1vw";
        inputText.style.borderRadius = "10px";
        inputText.style.width = "30vw";
        inputText.style.height = "10vmax";
        inputText.style.backgroundColor = "#ffffff";

        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "30vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "SET FPS";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            gameLoop.fakeFps = parseInt(inputText.value);
            hide();
        };

        inputText.value = gameLoop.fakeFps.toString();

        root.appendChild(inputText);
        root.appendChild(inputBtn);
    }

    private addSpeedDebugger(root: HTMLElement, hide: Function) {
        const inputText = document.createElement("input");
        inputText.type = "text";
        inputText.style.fontSize = "3vw";
        inputText.style.margin = "1vmax 1vw";
        inputText.style.borderRadius = "10px";
        inputText.style.width = "30vw";
        inputText.style.height = "10vmax";
        inputText.style.backgroundColor = "#ffffff";

        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "30vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "SET SPEED";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            gameLoop.setDebugSpeed(parseFloat(inputText.value));
            hide();
        };

        inputText.value = gameLoop.getSpeed().toString();

        root.appendChild(inputText);
        root.appendChild(inputBtn);
    }

    private addNetworkDelay(root: HTMLElement, hide: Function) {
        const inputText = document.createElement("input");
        inputText.type = "text";
        inputText.style.fontSize = "3vw";
        inputText.style.margin = "1vmax 1vw";
        inputText.style.borderRadius = "10px";
        inputText.style.width = "30vw";
        inputText.style.height = "10vmax";
        inputText.style.backgroundColor = "#ffffff";
        inputText.value = commsManager.getDelay().toString();

        const inputBtn = document.createElement("button");
        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "30vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";
        inputBtn.innerText = "SET NETWORK DELAY";

        inputBtn.onclick = () => {
            commsManager.setDelay(parseInt(inputText.value));
            hide();
        };

        root.appendChild(inputText);
        root.appendChild(inputBtn);
    }

    private addFPSToggle(root: HTMLElement) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "TOGGLE FPS";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            gameLoop.toggleStats();
        };
        root.appendChild(inputBtn);
    }

    private addAutoTurbo(root: HTMLElement, hide: Function) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "AUTO TURBO";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {

            const autoplayModel = slotModel.read().autoplay;
            autoplayModel.autoplays.currentValue = Number.POSITIVE_INFINITY;
            autoplayModel.lossLimit.currentValue = Number.POSITIVE_INFINITY;
            autoplayModel.singleWinLimit.currentValue = Number.POSITIVE_INFINITY;
            autoplayModel.stopOnFeatureWin = true;

            Services.autoplay.setAutoplays(Number.POSITIVE_INFINITY);
            Model.write({
                settings: {
                    quickSpin: false,
                    turboSpin: true
                }
            });
            slotModel.write({
                autoplay: {
                    lossLimit: autoplayModel.lossLimit,
                    singleWinLimit: autoplayModel.singleWinLimit,
                    stopOnFeatureWin: autoplayModel.stopOnFeatureWin
                }
            });

            uiFlags.set(UIFlag.AUTO_SPIN, true);

            Services.autoplay.start();

            stateMachine.skip();

            hide();
        };
        root.appendChild(inputBtn);
    }

    private addSpinTimer(root: HTMLElement) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "SPIN TIMER";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => debugSpinTimer.toggle();
        root.appendChild(inputBtn);
    }

    private addCrash(root: HTMLElement, hide: Function) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "CRASH GAME (2s)";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            hide();

            if (UtilTab.crashTimer) {
                Timer.clearTimeout(UtilTab.crashTimer);
                UtilTab.crashTimer = undefined;
            }
            UtilTab.crashTimer = Timer.setTimeout(() => {
                UtilTab.crashTimer = undefined;
                throw new Error("Game has crashed due to debug tools.");
            }, 2000);
        };
        root.appendChild(inputBtn);
    }

    private addMusicToggle(root: HTMLElement, hide: Function) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "TOGGLE MUSIC";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            Services.sound.setMusicMute(!Services.sound.getMusicMuted());
        };
        root.appendChild(inputBtn);
    }
}
